// ===============================================================
// ➕ FUNCIONES GLOBALES
// ===============================================================



/* 🛒 Estilos Cart Custom */

function $reindexacionRebuy(){
  $('#rebuy-cart .rebuy-cart__flyout').prepend('<div class="rebuy-new-cart"><div class="container-rebuy-cart-new"></div><div class="container-rebuy-cart-recommendation"></div></div>');
  $( "#rebuy-cart .rebuy-new-cart .container-rebuy-cart-new" ).append($( ".rebuy-cart__flyout-header, .rebuy-cart__flyout-body, .rebuy-cart__flyout-footer" ));
  $('#rebuy-cart .rebuy-new-cart .container-rebuy-cart-recommendation').append('<div data-rebuy-id="222726"></div>');
  $('#rebuy-cart .rebuy-new-cart .container-rebuy-cart-recommendation').append('<div data-rebuy-id="209748"></div>');
  $('#rebuy-cart .rebuy-cart__flyout-recommendations').prepend('<div data-rebuy-id="222731"></div>');

  $('#rebuy-cart .rebuy-cart__flyout-content').prepend('<div class="container-progress-bar-move"></div>');
  $( "#rebuy-cart .rebuy-cart__flyout-content .container-progress-bar-move" ).prepend($( "#rebuy-cart .rebuy-cart__flyout-body .rebuy-cart__progress-bar-container" ));

  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').before(
    '<div id="stars-rebuy-show">' + 
      '<div class="stars">' + 
        '<svg version="1.1" id="stars-reviews-rebuy-cart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 67 11.2" style="enable-background:new 0 0 67 11.2;" xml:space="preserve">' +
          '<g>' +
            '<polygon points="7.4,4.1 5.9,0 4.4,4.1 0,4.3 3.4,7 2.2,11.2 5.9,8.8 9.5,11.2 8.3,7 11.8,4.3"/>' +
          	'<polygon points="21.2,4.1 19.7,0 18.2,4.1 13.8,4.3 17.2,7 16,11.2 19.7,8.8 23.3,11.2 22.2,7 25.6,4.3"/>' +
          	'<polygon points="29.8,11.2 33.5,8.8 37.2,11.2 36,7 39.4,4.3 35,4.1 33.5,0 32,4.1 27.6,4.3 31,7"/>' +
          	'<polygon points="48.8,4.1 47.3,0 45.8,4.1 41.4,4.3 44.8,7 43.7,11.2 47.3,8.8 51,11.2 49.8,7 53.2,4.3"/>' +
          	'<polygon points="67,4.3 62.6,4.1 61.1,0 59.6,4.1 55.2,4.3 58.7,7 57.5,11.2 61.1,8.8 64.8,11.2 63.6,7"/>' +
          '</g>' +
        '</svg>' +
      '</div>' + 
      '<div class="message">' + 
        '<p><em>Thousands of Satisfied Customers</em></p>' + 
      '</div>' + 
    '</div>'
  );

  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note-toggle').prepend('<div class="container-checkbox"></div>');
  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note .container-checkbox').prepend($('.rebuy-cart__flyout-note-toggle > input, .rebuy-cart__flyout-note-toggle > span'));
  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note .container-checkbox').after('<p class="message-notes">You can add a note to totally free.</p>');

};

function ajustarAltura() {
  var alturaVisible = window.innerHeight + "px";
  document.querySelector('.container-rebuy-cart-new').style.height = alturaVisible;
  console.log(alturaVisible);
};

window.addEventListener("resize", ajustarAltura);



/* 🎁 Script Render GWP */

function $renderContainer(){

  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(
      `<div class="container-progress-bar">
        <div class="elements-progress-bar">
          <h3 class="progress-bar__title">Free shipping on orders +$75</h3>
          <section class="progress-bar-cart">
          
            <div class="progress-bar-cart__container">
              <div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>
            </div>
            <div class="progress-bar__icon">
              <div id="container-icon__free-shipping" class="progress-bar__icon-container">
                <i id="icon__free-shipping" class="fas fa-lock"></i>
              </div>
              <p class="progress-bar__icon-text">Free Shipping</p>
            </div>
            
            <div class="progress-bar-cart__container">
              <div id="progress-bar__pouch" class="progress-bar-cart__bar"></div>
            </div>
            <div class="progress-bar__icon">
              <div id="container-icon__pouch" class="progress-bar__icon-container">
                <i id="icon__pouch" class="fas fa-lock"></i>
              </div>
              <p class="progress-bar__icon-text">Gift With Purchase</p>
            </div>
            
          </section>
          <div class="disclaimer-message">
            <p>* Get a tortoiseshell acetate comb charm on us with your $150+ purchase. While supplies last!</p>
          </div>
        </div>
    </div>
    

    <div id="rebuy-promo-msg" style="display:none;" aria-live="polite"></div>

    `
  );
  
};



/* 👍 Script Progress Bar */

function $progressBar(totalPrice,arrayProducts){

    let $backgroundColor = '#fff';
    let $secondaryColor = '#47333e';

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $price_promotion_one = 7500 - $total_price; var $promotion_one = $price_promotion_one /= Math.pow(10, 2); var $porcentPromotionOne = ((75.00 - $promotion_one) / 75.00 * 100) + "%";
    var $price_promotion_two = 15000 - $total_price; var $promotion_two = $price_promotion_two /= Math.pow(10, 2); var $porcentPromotionTwo = ((150.00 - $promotion_two) / 150.00 * 100) + "%";

   
    function $product_offer(productId){return productId.product_id === 7400419393623;};var $validation_product = $array_products.find($product_offer);

    if ($validation_product !== undefined) {
      if($total_price <= 14999){
        jQuery.post('/cart/update.js', {
            updates: {
              41666994536535: 0
            }
        });
      } else if ($total_price >= 15000){
        let qty_product = $validation_product.quantity;
        let id_variant = $validation_product.id.toString();
        if (qty_product > 1 && (id_variant === '41666994536535')) {
          jQuery.post('/cart/update.js', {
            updates: {
              [id_variant]: 1
            }
          });
        };
      };
    };
    

  
    if($total_price <= 0){

      $("#progress-bar__free-shipping,#progress-bar__pouch").animate({width: "0%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": $backgroundColor, "border-color": $secondaryColor});
      $("#icon__free-shipping,#icon__pouch").css("color", $secondaryColor);
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on orders +$75</h3>');
      
    
    } else if($total_price > 0 && $total_price <= 7499){

      $("#progress-bar__free-shipping").animate({width: $porcentPromotionOne,}, 500);
      $("#progress-bar__pouch").animate({width: "0%",}, 500);
      
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>')
      
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": $backgroundColor, "border-color": $secondaryColor});
      $("#icon__free-shipping,#icon__pouch").css("color", $secondaryColor);

      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You need <b>$' + $promotion_one + '</b> to get free shipping</h3>');
      

    } else if($total_price >= 7500 && $total_price <= 14999){

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: $porcentPromotionTwo,}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>')

      $("#container-icon__free-shipping").css({"background-color": $secondaryColor, "border-color": $secondaryColor});
      $("#container-icon__pouch").css({"background-color": $backgroundColor, "border-color": $secondaryColor});

      $("#icon__free-shipping").css("color", $backgroundColor);
      $("#icon__pouch").css("color", $secondaryColor);

      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You need <b>$' + $promotion_two + '</b> to get a tortoiseshell acetate comb charm</h3>' +
          '<h5>You unlocked free shipping</h5>'+
        '</div>'
      );

    } else if($total_price >= 15000){

      if ($validation_product === undefined){
        var dataProduct = {
          "id": 41666994536535,
          "quantity": 1
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataProduct,
          dataType: 'json',
          success: function() { 
            
          }
        });
      } else {
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You unlocked free shipping + gift with purchase</h3>');
      };

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: "100%",}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-check-circle"></i>');

      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": $secondaryColor, "border-color": $secondaryColor});

      $("#icon__free-shipping,#icon__pouch").css("color", $backgroundColor);
      
    };
  
};




// ===============================================================
// 🏃‍♂️ TRIGGERS REBUY
// ===============================================================



/* 🛒 Carrito Listo */

document.addEventListener('rebuy:smartcart.ready', function(event){
  console.log('rebuy:smartcart.ready event', event.detail);
  var $qty = event.detail.smartcart.cart.item_count;
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;

  $('span.thb-item-count').text($qty);

  $('#rebuy-cart .rebuy-cart__flyout-content').on('scroll', function() {
    if ($(this).scrollTop() > 0) {
      $('#rebuy-cart .rebuy-cart__flyout-header').addClass('scroll-move-header');
    } else {
      $('#rebuy-cart .rebuy-cart__flyout-header').removeClass('scroll-move-header');
    }
  });

  $renderContainer();
  $progressBar($total_price,$array_products);
  
  $reindexacionRebuy();
  ajustarAltura();

  renderGroupSet();
  setTimeout(GroupSet, 1000);
});



/* 🛒 Cambios en el Carrito */

document.addEventListener('rebuy:cart.change', function(event){
  console.log('rebuy:cart.change event', event.detail);

  var $container_progress = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  var $qty = event.detail.cart.cart.item_count;
  var $total_price = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;

  $('span.thb-item-count').text($qty);

  if ($container_progress.length > 0) {
    $progressBar($total_price,$array_products);
  };

  setTimeout(function() {
    var $container_messageNote = $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note-toggle .container-checkbox');
    if ($container_messageNote.length === 0) {
      $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note-toggle').prepend('<div class="container-checkbox"></div>');
      $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note .container-checkbox').prepend($('.rebuy-cart__flyout-note-toggle > input, .rebuy-cart__flyout-note-toggle > span'));
      $('.rebuy-cart__flyout-content .rebuy-cart__flyout-note .container-checkbox').after('<p class="message-notes">Add a note at no extra cost.</p>');
    }
  }, 300);


  var $containerSets = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-sets');
  if ($containerSets.length > 0) {
    setTimeout(GroupSet, 1000);
  };
  
});





/* Script para SETS */

function renderGroupSet(){
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar').after('<div class="rebuy-cart__flyout-sets"><h4 id="heading-product-sets">Product Sets:</h4></div><div class="title-simple-products">Individual Products:</div>');
};



function GroupSet(){

  var grupos = {};
  var cantidadElementos = 0;
  var lineItemsBasic = 0;
    
  $("div#rebuy-cart ul.rebuy-cart__flyout-items li.rebuy-cart__flyout-item").each(function() {
  
      var classes = $(this).attr("class").split(" ");
      var idClass = classes.find(function(className) {
          return className.startsWith("property-id-set:"); 
      });
  
      if (idClass) {
          var id = idClass.split(":")[1];
        
          if (!grupos[id]) {
              grupos[id] = [];
          };
          
          grupos[id].push(this);
      } else {
        
        lineItemsBasic++;
        
      };
      
  });

  for (var id in grupos) {
    if($('div#rebuy-cart .rebuy-cart__flyout-sets ul.' + id).length === 0){

      var priceTravelSetAmount = 75;
      var priceTravelSet = '$'+ priceTravelSetAmount +'.00';
      

      var lista = $("<ul class='" + id + "'></ul>");
      
      var containerSet = $(`
        <div class="container-set-rebuy container-set-rebuy--${id}">
          <div class="rebuy-cart__flyout-item">
            <div class="rebuy-cart__flyout-item-media">
              <a href="/products/charm-build-it-your-own" tabindex="-1">
                <img src="https://cdn.shopify.com/s/files/1/1345/3619/files/TRIO_240x240.jpg">
              </a>
            </div>
            <div class="rebuy-cart__flyout-item-info">
              <a role="heading" aria-level="5" href="/products/charm-build-it-your-own" class="rebuy-cart__flyout-item-product-title">
                Charm Build it Your Own
              </a>
              <div class="rebuy-cart__flyout-item-discount-message rebuy-cart__flyout-item-discount-message--hide"></div>
              <div class="rebuy-cart__flyout-item-properties">
                <div class="rebuy-cart__flyout-item-property property-key-id-set">
                  <span class="rebuy-cart__flyout-item-property-name">ID SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value">${id}</span>
                </div>
              </div>
              <button type="button" class="rebuy-cart__flyout-item-remove">
                <i aria-hidden="true" class="far fa-trash"></i>
              </button>
              <div class="rebuy-cart__flyout-item-quantity">
                <div class="container-button-view-all-products">
                  <span class="view-products button-active">View Products</span>
                </div>
              </div>
              <div class="rebuy-cart__flyout-item-price">
                <div>
                  <span class="rebuy-money-sale"><span></span></span>
                  <span class="rebuy-money-regular"><span class="sr-only">Price</span> <span></span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);



      
      var elementosOriginales = grupos[id];


      if (elementosOriginales.length >= 1) {
        elementosOriginales.forEach(function(elementoOriginal) {
            var copiaElemento = $(elementoOriginal).clone();
            lista.append(copiaElemento);
        }); 
      };
      

      $('.rebuy-cart__flyout-sets').prepend(containerSet);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +'').append(lista);
      
    };

    cantidadElementos++;

  };


  $('.rebuy-cart__flyout-sets').prepend($('#heading-product-sets'));


  $('.rebuy-cart__flyout-sets .container-set-rebuy').each(function(){
      var selector = $(this).find('> div.rebuy-cart__flyout-item');
      var items = $(this).find('ul li');
      var totalSet = 0;
      var totalSetOffer = 0;
      var totalSetRegular = 0;
      items.each(function(){

        
        // SET EN GOLD WHITE IMAGEN
        if($(this).hasClass('product-full-diamond-white-gold-bold-initial')){
          var urlChange = 'https://saritawaich.com/products/build-your-necklace-full-diamond-white-gold-bold-initial';
          var imagenChange = 'https://cdn.shopify.com/s/files/1/0537/0675/2158/files/a_6ad60c5f-747b-4c66-81d2-8a371ff1a848_240x240.jpg'; 
          $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
        };


        // SET EN GOLD BOLD IMAGEN
        if($(this).hasClass('product-full-diamond-bold-initial')){
          var urlChange = 'https://saritawaich.com/products/build-your-necklace-full-diamond-bold-initial';
          var imagenChange = 'https://cdn.shopify.com/s/files/1/0537/0675/2158/files/a_240x240.jpg'; 
          $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
        };


        
        let discount = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message');
        if (discount.length > 0) {
          $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').text(discount.text());
          $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').removeClass('rebuy-cart__flyout-item-discount-message--hide');
        };

        /* Precio Normal sin Descuento */
        let priceValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text();
        let price = Math.round(parseFloat(priceValue.replace(/[$,]/g, '')) * 100);
        totalSet += price;

        /* Precio Oferta con Cupón */
        let priceSaleValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)').text();
        let priceSale = Math.round(parseFloat(priceSaleValue.replace(/[$,]/g, '')) * 100);
        totalSetOffer += priceSale;

        /* Precio Regular con Cupón */
        let priceRegularValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)').text();
        let priceRegular = Math.round(parseFloat(priceRegularValue.replace(/[$,]/g, '')) * 100);
        totalSetRegular += priceRegular;

      });

      if(totalSetOffer > 0){
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular').addClass('rebuy-money-regular__crossline');
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-sale span:not(.sr-only)').text((totalSetOffer / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSetRegular / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      } else {
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSet / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      }

  });



  
  
  if(cantidadElementos > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').hide();
  };

  if(lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').hide();
  };


  if(cantidadElementos > 0 && lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').show();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').hide();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').hide();
  };


};




$(document).on('click', '.container-set-rebuy button.rebuy-cart__flyout-item-remove', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Remove set</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});



$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-active', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideDown();
  $(this).text('Hide Products');
  $(this).removeClass('button-active');
  $(this).addClass('button-off');
});

$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-off', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideUp();
  $(this).text('View Products');
  $(this).removeClass('button-off');
  $(this).addClass('button-active');
});